const Footer = () => {

  return (
    <footer className="main-footer sidebar-dark-primary text-white py-4" style={{ backgroundColor: "#2d9053ff" }}>
      <div className="container">
        <div className="row">
          {/* Información Principal */}
          <div className="col-md-4 mb-3">
            <h5 className="fw-bold text-white">DESOFIW</h5>
            <p className="text-white">
              Desarrollo de sofware para oficina y web
            </p>
          </div>
        </div>
        <div className="text-center mt-3">
          <p className="text-white mb-0">
            &copy; 2024 DESOFIW. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
